export enum WorkflowStatusEnum {
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
}
